export default __webpack_public_path__ + "static/media/ship.5133e415.svg";